import React, { useEffect, useState } from 'react';
import { X, Cake, Sparkles } from 'lucide-react';

/** Portal banner with today's greeting graphic(s) from the Calendar Autopilot. */
export default function AutopilotBanner({ apiUrl, agentId }) {
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('ap-banner-dismissed') === new Date().toISOString().slice(0, 10));

  useEffect(() => {
    if (!agentId || agentId === 'admin') return;
    (async () => {
      try {
        const r = await fetch(`${apiUrl}/api/agents/${agentId}/autopilot/today`);
        if (r.ok) setItems((await r.json()).greetings || []);
      } catch (e) { console.error('autopilot banner', e); }
    })();
  }, [apiUrl, agentId]);

  if (dismissed || items.length === 0) return null;
  const main = items[0];
  const dismiss = () => { sessionStorage.setItem('ap-banner-dismissed', new Date().toISOString().slice(0, 10)); setDismissed(true); };

  return (
    <div className="relative mb-6 rounded-xl overflow-hidden border border-[#D4AF37]/60 bg-[#FBF8F1] shadow-sm" data-testid="autopilot-banner">
      <button type="button" onClick={dismiss} className="absolute top-2 right-2 z-10 bg-white/80 rounded-full p-1 text-gray-600 hover:text-gray-900" aria-label="Dismiss" data-testid="autopilot-banner-dismiss"><X className="h-4 w-4" /></button>
      <div className="flex flex-col md:flex-row">
        {main.graphic_path && <img src={`${apiUrl}${main.graphic_path}`} alt={main.title} className="md:w-[420px] w-full object-cover" data-testid="autopilot-banner-graphic" />}
        <div className="p-5 flex-1">
          <p className="text-xs font-bold uppercase tracking-wider text-[#D4AF37] flex items-center gap-1">{main.kind === 'birthday' ? <Cake className="h-3.5 w-3.5" /> : <Sparkles className="h-3.5 w-3.5" />} Today at Utmost</p>
          <h3 className="text-xl font-serif font-bold text-[#0A2A43] mt-1" data-testid="autopilot-banner-title">{main.title}</h3>
          <p className="text-sm text-gray-700 mt-1" data-testid="autopilot-banner-message">{main.message}</p>
          {items.length > 1 && (
            <ul className="mt-3 space-y-1 text-sm text-gray-700" data-testid="autopilot-banner-more">
              {items.slice(1).map((it, i) => <li key={i} className="flex items-center gap-2">{it.kind?.includes('birthday') ? <Cake className="h-3.5 w-3.5 text-pink-600" /> : <Sparkles className="h-3.5 w-3.5 text-[#0077B6]" />} <b>{it.title}</b> {it.message && <span className="text-gray-500">— {it.message}</span>}</li>)}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
